import React from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';
import HomeIcon from '@mui/icons-material/Home';

function Contact() {

    return (
        <div>
            <h2> My Contact details</h2>
                <div className="Conventional">             
                    <ul>
                        <li><h3> Email<AlternateEmailIcon/>: Saurabhjaiswaljazzy@gmail.com</h3></li>
                        <li><h3>Mobile Number<MobileScreenShareIcon/>: +66-(0)-969369715 </h3></li>
                        <li><h3>My Address<HomeIcon/>: 49/139 Moo.5. Ban Wararak Rangsit Khlong 4, Tambon Lat Sawai, Amphoe Lam Luk Ka, Province Pathum Thani 12150 </h3></li>
                    </ul>
                </div>
                
        </div>
    )
}

export default Contact
